/* ForeFrontier theme */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function load(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }
  function save(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  /* mobile nav */
  var toggle = document.querySelector('[data-nav-toggle]');
  if (toggle) toggle.addEventListener('click', function () {
    var open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    document.body.classList.toggle('nav-open', !open);
  });

  /* header state on scroll */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* product gallery and price */
  var main = document.querySelector('.product__main');
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!main) return;
      main.removeAttribute('srcset'); main.src = b.getAttribute('data-src');
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (o) { o.removeAttribute('aria-current'); });
      b.setAttribute('aria-current', 'true');
    });
  });
  var priceEl = document.querySelector('[data-price]');
  document.querySelectorAll('.variant input').forEach(function (r) {
    r.addEventListener('change', function () { if (priceEl) priceEl.textContent = r.getAttribute('data-price'); });
  });

  /* golf places for the crest */
  var PLACES = {
    'algarve': [37.08, -8.12], 'vilamoura': [37.08, -8.12], 'quinta do lago': [37.03, -8.02], 'vale do lobo': [37.05, -8.06],
    'comporta': [38.38, -8.78], 'lisbon': [38.72, -9.14], 'marbella': [36.51, -4.88], 'costa del sol': [36.51, -4.88],
    'sotogrande': [36.29, -5.28], 'valderrama': [36.29, -5.30], 'mallorca': [39.57, 2.65], 'majorca': [39.57, 2.65],
    'tenerife': [28.29, -16.63], 'crans-montana': [46.31, 7.48], 'crans montana': [46.31, 7.48], 'geneva': [46.20, 6.14],
    'lausanne': [46.52, 6.63], 'evian': [46.40, 6.59], 'bad ragaz': [47.00, 9.50], 'belek': [36.86, 31.06],
    'antalya': [36.90, 30.70], 'costa navarino': [36.99, 21.66], 'le touquet': [50.52, 1.59], 'marrakech': [31.63, -7.99],
    'dubai': [25.20, 55.27], 'st andrews': [56.34, -2.80], 'st. andrews': [56.34, -2.80], 'carnoustie': [56.50, -2.71],
    'kingsbarns': [56.30, -2.65], 'gullane': [56.04, -2.83], 'muirfield': [56.04, -2.82], 'north berwick': [56.06, -2.72],
    'turnberry': [55.31, -4.83], 'troon': [55.54, -4.66], 'prestwick': [55.50, -4.61], 'dornoch': [57.88, -4.03],
    'portrush': [55.20, -6.65], 'newcastle': [54.22, -5.89], 'royal county down': [54.22, -5.89], 'ballybunion': [52.51, -9.67],
    'lahinch': [52.93, -9.35], 'kinsale': [51.71, -8.52], 'adare': [52.56, -8.79], 'pebble beach': [36.57, -121.95],
    'scottsdale': [33.49, -111.93], 'kiawah': [32.61, -80.08], 'kiawah island': [32.61, -80.08], 'pinehurst': [35.20, -79.47],
    'hua hin': [12.57, 99.96]
  };
  function fmt(lat, lng) {
    return Math.abs(lat).toFixed(2) + '\u00B0 ' + (lat >= 0 ? 'N' : 'S') + ' \u00B7 ' + Math.abs(lng).toFixed(2) + '\u00B0 ' + (lng >= 0 ? 'E' : 'W');
  }

  window.FF_PLACES = PLACES; window.FF_fmt = fmt;

  function fitPlace(el) {
    var len = el.textContent.length;
    el.style.setProperty('--place-scale', len <= 8 ? 1 : Math.max(0.5, 8 / len).toFixed(3));
  }

  /* crest builder */
  var crest = document.querySelector('.trip [data-crest]');
  if (crest) {
    var placeOut = crest.querySelector('[data-crest-place]');
    var tripOut = crest.querySelector('[data-crest-trip]');
    var coordsOut = crest.querySelector('[data-crest-coords]');
    var hint = document.querySelector('[data-crest-hint]');
    var placeIn = document.querySelector('[data-crest-input="place"]');
    var tripIn = document.querySelector('[data-crest-input="trip"]');
    var colourIn = document.querySelector('[data-crest-input="colour"]');
    var update = function () {
      var p = (placeIn.value || 'Algarve').trim();
      placeOut.textContent = p; fitPlace(placeOut);
      tripOut.textContent = (tripIn.value || 'Tour 2027').trim();
      var hit = placeIn.dataset.lat ? [Number(placeIn.dataset.lat), Number(placeIn.dataset.lon)] : PLACES[p.toLowerCase()];
      if (hit) { coordsOut.textContent = fmt(hit[0], hit[1]); coordsOut.classList.remove('is-pending'); if (hint) hint.textContent = 'These coordinates are stitched on under the trip name.'; }
      else if (placeIn.value) { coordsOut.textContent = 'Coordinates added in your proof'; coordsOut.classList.add('is-pending'); if (hint) hint.textContent = 'We\u2019ll add the exact coordinates of your course in the proof.'; }
      else { coordsOut.textContent = fmt(37.08, -8.12); coordsOut.classList.remove('is-pending'); }
      var sp = document.querySelector('[data-sum-place]'), st = document.querySelector('[data-sum-trip]'), sk = document.querySelector('[data-sum-kit]');
      if (sp) sp.textContent = placeIn.value.trim() || 'Add a place in step 1';
      if (st) st.textContent = tripIn.value.trim() || 'Add a trip name';
      if (sk) sk.textContent = (colourIn && /^navy/i.test(colourIn.value)) ? 'Navy kit' : 'White kit';
      var navy = colourIn && /^navy/i.test(colourIn.value);
      crest.classList.toggle('crest--navy', navy); crest.classList.toggle('crest--stone', !navy);
    };
    var qs = new URLSearchParams(location.search);
    if (qs.get('place')) placeIn.value = qs.get('place').slice(0, 18);
    if (qs.get('trip')) tripIn.value = qs.get('trip').slice(0, 22);
    [placeIn, tripIn, colourIn].forEach(function (el) { if (el) el.addEventListener('input', update); });
    if (colourIn) colourIn.addEventListener('change', update);
    update();
  }

  /* hero crest: one quiet cycle through real destinations */
  var cycle = document.querySelector('[data-crest-cycle] [data-crest]');
  if (cycle && !reduceMotion) {
    var sets = [
      ['Algarve', 'Tour 2027', 37.08, -8.12, 'stone'],
      ['Dornoch', 'Lads 2026', 57.88, -4.03, 'navy'],
      ['Crans-Montana', 'Stag 2027', 46.31, 7.48, 'stone'],
      ['Ballybunion', 'Society 2027', 52.51, -9.67, 'navy']
    ];
    var i = 0, plate = cycle.querySelector('.crest__plate');
    setInterval(function () {
      i = (i + 1) % sets.length; var s = sets[i];
      plate.classList.add('is-changing');
      setTimeout(function () {
        cycle.querySelector('[data-crest-place]').textContent = s[0];
        cycle.querySelector('[data-crest-trip]').textContent = s[1];
        cycle.querySelector('[data-crest-coords]').textContent = fmt(s[2], s[3]);
        fitPlace(cycle.querySelector('[data-crest-place]'));
        cycle.classList.toggle('crest--navy', s[4] === 'navy'); cycle.classList.toggle('crest--stone', s[4] !== 'navy');
        plate.classList.remove('is-changing');
      }, 420);
    }, 3600);
  }

  /* partner referral: ?ref=CODE is kept for 30 days */
  var params = new URLSearchParams(location.search);
  var ref = params.get('ref') || params.get('partner');
  if (ref) save('ff_ref', { code: ref.slice(0, 40), until: Date.now() + 30 * 864e5 });
  var saved = load('ff_ref');
  var refField = document.querySelector('[data-ref-field]');
  if (refField && saved && saved.until > Date.now() && !refField.value) refField.value = saved.code;

  /* UK and EU visitors: point them to Etsy */
  var note = document.querySelector('[data-etsy-note]');
  var EU = 'GB IE FR DE ES PT IT NL BE LU AT DK SE FI PL CZ SK SI HR HU RO BG GR CY MT EE LV LT';
  if (note && !load('ff_etsy_dismissed')) {
    fetch('/browsing_context_suggestions.json').then(function (r) { return r.json(); }).then(function (d) {
      var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
      if (c && EU.indexOf(c.toUpperCase()) > -1) note.hidden = false;
    }).catch(function () {});
    var close = note.querySelector('[data-etsy-close]');
    if (close) close.addEventListener('click', function () { note.hidden = true; save('ff_etsy_dismissed', true); });
  }

  /* basket: remind about the game code */
  var cartReward = document.querySelector('[data-cart-reward]');
  var reward = load('ff_reward');
  if (cartReward && reward && window.FF && window.FF.codes && window.FF.codes[reward.tier]) {
    cartReward.querySelector('[data-cart-reward-code]').textContent = window.FF.codes[reward.tier];
    cartReward.hidden = false;
  }
})();
